/* eslint-disable @typescript-eslint/no-unused-vars */
import axios from "axios";
import store from "../../store/index";
import monitorKpiModal from "../monitor-kpi-modal/monitor-kpi-modal.vue";
import moment from "moment";
export default {
    name: "MonitorDashboard",
    components: {
        monitorKpiModal
    },
    data() {
        return {
            performanceList: [],
            baseapi: process.env.VUE_APP_Service_URL,
            kpiWithScores: [],
            openModal: false
        };
    },


    mounted() {
        this.listSitePerformance();
        window.addEventListener("studyIdChanged", (event) => {
            console.log("StudyIDChanged into" + event.detail.storage);
            // window.location.reload();
            this.listSitePerformance();
        });

    },
    methods: {
        async listSitePerformance() {
            const idtoken = store.getters.getIdToken;
            this.studyId = store.getters.getStudyIs;
            axios
                .get(`${this.baseapi}/forms/rbqm/getstudysitesummary?studyId=${this.studyId}`, {
                    headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json",
                    },
                })
                .then((res) => {
                    this.performanceList = res.data;

                })
                .catch(async (err) => {
                    console.log(err);
                });
        },
        async viewDocument(kpiWithScores) {
            this.kpiWithScores = kpiWithScores;
            this.openModal = true;
        },
        closeModal() {
            this.openModal = false;
        },
        formatRunDate(date) {
            if (!date) return "-";
            return moment.utc(date).local().format("DD-MM-YYYY");
        }

    },

};
